import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useAuth = () => useSelector((state: RootState) => state.login);
